import React, { useEffect, useState } from "react";
import { getPrivacyPolicy } from "../api/api";

const RefundPolicy = () => {
  const [policy, setPolicy] = useState("");

  useEffect(() => {
    const fetchPolicy = async () => {
      const response = await getPrivacyPolicy();
      if (response.status && response.data && response.data.refund_policy) {
        setPolicy(response.data.refund_policy);
      } else {
        setPolicy("<p>Failed to load refund policy.</p>");
      }
    };

    fetchPolicy();
  }, []);

  return (
    <div className="custom-padding xl-screen-padding pt-80 pb-80 font-lato">
      <div className="policy-content" dangerouslySetInnerHTML={{ __html: policy }} />
    </div>
  );
};

export default RefundPolicy;
